import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import FOAM_API from "../../../../utils/api";
import { getToken } from "../../../../utils/auth";

const initialState = {
  data: [],
  loading: false,
  error: null
};

// Define the asynchronous thunk for fetching data
export const longBunSkus = createAsyncThunk("foam/fetchData", async () => {
  const response = await fetch(FOAM_API + "/fetch-long-bun-skus");
  const data = await response.json();
  return data;
});

export const createLongBunSchedule = createAsyncThunk(
  "foam/postLongBunSchedule",
  async (requestData) => {
    const token = await getToken();
    if (!token) {
      throw new Error("Authentication token not found in Azure.");
    }
    const response = await fetch(FOAM_API + "/post-long-bun-schedule", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(requestData) // Make sure to pass the required data here
    });
    const data = await response.json();
    return data;
  }
);

export const fetchLongBunByDate = createAsyncThunk(
  "foam/fetchByDate",
  async (requestData) => {
    const token = await getToken();
    if (!token) {
      throw new Error("Authentication token not found in Azure.");
    }
    const response = await fetch(
      FOAM_API + "/fetch-long-bun-schedule-by-date",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",

          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(requestData) // Make sure to pass the required data here
      }
    );
    const data = await response.json();
    return data;
  }
);

export const updateLongBun = createAsyncThunk(
  "foam/updateLongBun",
  async (requestData) => {
    const token = await getToken();
    if (!token) {
      throw new Error("Authentication token not found in Azure.");
    }
    const response = await fetch(FOAM_API + "/update-long-bun-schedule", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(requestData) // Make sure to pass the required data here
    });
    const data = await response.json();
    return data;
  }
);

export const foamSlice = createSlice({
  name: "foam",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(longBunSkus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(longBunSkus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(longBunSkus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create Long Bun Schedule
      .addCase(createLongBunSchedule.pending, (state) => {
        state.loading = true;
        state.createLongBunError = null;
      })
      .addCase(createLongBunSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.createLongBunData = action.payload;
      })
      .addCase(createLongBunSchedule.rejected, (state, action) => {
        state.loading = false;
        state.createLongBunError = action.error.message;
      })

      // Get Long Bun By Date
      .addCase(fetchLongBunByDate.pending, (state) => {
        state.loading = true;
        state.fetchLongBunByDateError = null;
      })
      .addCase(fetchLongBunByDate.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchLongBunByDate = action.payload;
      })
      .addCase(fetchLongBunByDate.rejected, (state, action) => {
        state.loading = false;
        state.fetchLongBunByDateError = action.error.message;
      })

      //update Long Bun
      .addCase(updateLongBun.pending, (state) => {
        state.loading = true;
        state.updateLongBunError = null;
      })
      .addCase(updateLongBun.fulfilled, (state, action) => {
        state.loading = false;
        state.updateLongBunData = action.payload;
      })
      .addCase(updateLongBun.rejected, (state, action) => {
        state.loading = false;
        state.updateLongBunError = action.error.message;
      });
  }
});

// Action creators are generated for each case reducer function

export default foamSlice.reducer;
